import { Folder, Genus } from "./genus";

export class AspectCheck {
    private readonly insAspects: string[] = [];
    private readonly delAspects: string[] = [];
    private readonly insAttributes: string[] = [];
    private readonly delAttributes: string[] = [];

    constructor(
        private readonly genus: Genus
    ) {
    }

    check(aspectIds: string[], attributeIds: string[]): void {
        this.insAspects.length = 0;
        this.delAspects.length = 0;
        this.insAttributes.length = 0;
        this.delAttributes.length = 0;

        const beforeAspects = this.genus.aspects ?? [];
        const afterAspects = aspectIds ?? [];

        beforeAspects.forEach(id => {
            if (!afterAspects.includes(id)) {
                this.delAspects.push(id);
            }
        });

        afterAspects.forEach(id => {
            if (!beforeAspects.includes(id)) {
                this.insAspects.push(id);
            }
        });

        const beforeAttributes = this.genus.attributes ?? [];
        const afterAttributes = attributeIds ?? [];

        beforeAttributes.forEach(id => {
            if (!afterAttributes.includes(id)) {
                this.delAttributes.push(id);
            }
        });

        afterAttributes.forEach(id => {
            if (!beforeAttributes.includes(id)) {
                this.insAttributes.push(id);
            }
        });
    }

    applyDelta() {
        this.cascadeDelta(this.genus);
    }

    private cascadeDelta(genus: Genus, childrenOnly: boolean = false) {
        if (genus instanceof Folder && !childrenOnly) {
            const folder = genus as Folder;
            if (!folder.inheritAspects) {
                folder.inheritAspects = [];
            } else if (folder.inheritAspects.length) {
                this.delAspects.forEach(id => {
                    const index = folder.inheritAspects!.indexOf(id);
                    if (index >= 0) {
                        folder.inheritAspects!.splice(index, 1);
                    }
                });
            }

            this.insAspects.forEach(id => {
                folder.inheritAspects!.push(id);
            });

            if (!folder.inheritAttributes) {
                folder.inheritAttributes = [];
            } else if (folder.inheritAttributes.length) {
                this.delAttributes.forEach(id => {
                    const index = folder.inheritAttributes!.indexOf(id);
                    if (index >= 0) {
                        folder.inheritAttributes!.splice(index, 1);
                    }
                });
            }

            this.insAttributes.forEach(id => {
                folder.inheritAttributes!.push(id);
            });
        }

        if (genus.branches?.length) {
            genus.branches.forEach(branch => {
                if (branch instanceof Folder) {
                    this.cascadeDelta(branch);
                }
            });
        }
    }
}
